/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconPause from '@telus-uds/palette-allium/build/rn/icons/Pause'
import PaletteIconPlaySolid from '@telus-uds/palette-allium/build/rn/icons/PlaySolid'
import PaletteIconReplay from '@telus-uds/palette-allium/build/rn/icons/Replay'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    borderColor: '#b2b9bf',
    pauseIcon: PaletteIconPause,
    playIcon: PaletteIconPlaySolid,
    replayIcon: PaletteIconReplay
  }
}
export default theme
